import React, { useEffect } from 'react';
import { Box, Container, Text } from '@chakra-ui/react';
import { useColorMode } from '@/components/ui/color-mode';
import Header from '@/components/layout/_shared/header';
import { Routes, Route, useNavigate } from 'react-router-dom';
import InitPage from './pages';
import LoginPage from './pages/login';
import CreateAccountPage from './pages/create-account';
import { Toaster } from './components/ui/toaster';
import MainPage from './pages/main';
import PWAInstallPage from './pages/pwa-install';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { setUnauthorizedCallback } from '@/api/client';

function App() {
  // カラーモードをライトに設定
  const { setColorMode } = useColorMode();
  useEffect(() => {
    setColorMode('light');
  });

  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

function AppContent() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  // 403エラー時の処理を設定
  useEffect(() => {
    setUnauthorizedCallback(async () => {
      // トークンを破棄してログアウト処理を実行
      await logout();
      navigate('/', { replace: true });
    });
  }, [navigate, logout]);

  return (
    <Container
      maxW={'breakpoint-xl'}
      bgColor={'teal.50'}
      // minH={'100vh'}
      height={'100dvh'}
      display={'flex'}
      flexDir={'column'}
      overflowY={'auto'}
    >
      {/* ヘッダー */}
      <Header />

      {/* ルーティング */}
      <Routes>
        <Route path="/" element={<InitPage />} />
        <Route path="/sample" element={<SampleContents />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/create-account" element={<CreateAccountPage />} />
        <Route path="/pwa-install" element={<PWAInstallPage />} />
        <Route
          path="/main/*"
          element={
            <ProtectedRoute>
              <MainPage />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Toaster />
    </Container>
  );
}

function SampleContents() {
  return (
    <>
      {/* コンテンツ */}
      <Box flex={1} mt={16}>
        <Text>スクロールしてもヘッダーは固定されます。この部分にコンテンツが続きます。</Text>
        {/* 以下に長いコンテンツを追加してスクロールを確認 */}
        {[...Array(30)].map((_, index) => (
          <Text key={index}>スクロールできるコンテンツ {index + 1}</Text>
        ))}
      </Box>
    </>
  );
}

export default App;
